<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import pbevidenceAPI from "@/services/standards/preventionbrigade/pbevidenceAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal"
import { sendNotification } from "@/utils/helpers/notification"
import DontExist from "@/components/company/components/DontExist"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {

  page: {
    title: "5.1.2 Brigada de emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    DontExist,
  },
  data() {

    return {
      title: "5.1.2 Brigada de emergencias",
      items: [

        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "5.1.2 Brigada de emergencias",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],

      item: null,
      itemData: null,

      file: null,
      listaII: null,
      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
        exam_status: 0,
      },

      file: null,
      submitted: false,
      capacitaciones: [],

      pbevidence: {
        capacitation_date: null,
        employee_id: null,
        prevention_brigades_id: null,
        pbtraining_id: null,
        file: null,
      },

      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading: true,

    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if(this.file === null){
          name = this.getFile(this.pbevidence.file)
        }else{
          name = this.file.name
        }

        if( process.env.VUE_APP_ENV === 'development' ){
          url = `sst-dev/${this.nit}/5.1.2/${this.pbevidence.prevention_brigades_id}/evidencia/${this.pbevidence.employee_id}/${name}`;
        }else{
          url = `sst-prod/${this.nit}/5.1.2/${this.pbevidence.prevention_brigades_id}/evidencia/${this.pbevidence.employee_id}/${name}`;
        }

        if(this.file === null){
          return true;
        }else{
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.pbevidence.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },


    getpbevidence() {
      pbevidenceAPI.getpbevidence(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.pbevidence = {
            id: response[0].id,
            employee_id: response[0].employee_id,
            capacitation_date: response[0].capacitation_date,
            prevention_brigades_id: response[0].pbrigades_id,
            file: response[0].file,
            pbtraining_id: response[0].training_id,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        pbevidenceAPI.updatepbevidence(this.$route.params.id, {
          id: this.pbevidence.id,
          employee_id: this.pbevidence.employee_id,
          capacitation_date: this.pbevidence.capacitation_date,
          prevention_brigades_id: this.pbevidence.prevention_brigades_id,
          file: this.pbevidence.file,
          pbtraining_id: this.pbevidence.pbtraining_id,
        })
        .then((response) => {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Informacion actualizada con éxito!",
              text: "¡Informacion actualizada con éxito!",
              type: "success",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
          this.$router.go(-1);
        });
      }else{
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No see ha podido actualizar!",
            text: "¡No see ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              let informacion = res.employee
              this.usersList = informacion
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCapacitacion() {
      pbevidenceAPI.getCapacitacion()
        .then((response) => {
          let brigada = response.Pb_training;
          this.capacitaciones = brigada
        })
        .catch((error) => {
          console.log(error);
        });
    },


    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 52)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

  },

  mounted() {
    this.getUsers();
    this.getpbevidence();
    this.getItems()
    this.getItemData();
    this.getCapacitacion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">

      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">

                      La empresa deberá realizar las evaluaciones médicas ocupacionales de ingreso, periódicas, de
                      egreso, post incapacidad y por cambio de ocupación, dando cumplimiento a lo establecido por la
                      resolución 2346 de 2007. Se deberá almacenar los conceptos de aptitud laboral que respalden la
                      realización de las evaluaciones, además la empresa deberá contar con la documentación de la IPS
                      que realice las evaluaciones, como son: Licencia en SST y certificado de habilitación.
                    </p>
                  </CheckModal>
                </div>
              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select required class="form-control" v-model="pbevidence.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha de capacitación" label-for="date_exam">
                    <b-form-input type="date" id="date_exam" v-model="pbevidence.capacitation_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Seleccionar capacitación">
                    <select required class="form-control" v-model="pbevidence.pbtraining_id">
                      <b-form-select-option v-for="item in capacitaciones" :key="item.id" :value="item.id">
                        {{ item.title }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir evidencia de capacitación" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()"  type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="pbevidence.file
                        ? getFile(pbevidence.file)
                        : `Selecciona un archivo...` " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label-for="input-sm">
                    <b-form-input type="text" hidden id="id" v-model="pbevidence.prevention_brigades_id">
                    </b-form-input>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>